export default __webpack_public_path__ + "static/media/tutorials1-e1454394356776.81c37160.jpg";